import { mapParamsBySchema, mapRowsBySchema } from '../../../../util';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import { M_TBG_CUSTOM_07_Schema } from './M_TBG_CUSTOM_07_Schema';
import useSearchMutaion from '../../../../Hooks/apis/useSearchMutaion';
import useSaveMutation from '../../../../Hooks/apis/useSaveMutaion';

/** TBM 참석인원 조회 GetM20903R1 */
export const useSearch1 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(
      M_TBG_CUSTOM_07_Schema.mapper.search1,
      context
    );
    return apiRequest('post', Global.urls.TBM.getTbmR4, params);
  }, successOptions);
};

/** 추가회의 저장 SaveM20906U1 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_TBG_CUSTOM_07_Schema.mapper.save1);
    return apiRequest('post1', Global.urls.TBM.saveTbmBasicU2, payload);
  }, options);
};

/** 교육현황 저장 SaveTbmStatusU1 */
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_TBG_CUSTOM_07_Schema.mapper.save2);
    return apiRequest('post1', Global.urls.TBM.saveTbmStatusU1, payload);
  }, options);
};
